<template>
  <div>
    <div class="p-0 m-0">
      <b-form-input
        v-model="x1Value"
        :state="(x1Value === '' && x0Value === '' && intercpValue === '') || (x1Value !== '' && !isNaN(x1Value))"
        aria-describedby="input-live-help input-live-feedback"
        placeholder="X1"
        trim
        size="sm"
        @change="updateCoefficients"
      />
      <b-form-invalid-feedback class="input-live-feedback">
        If one variable is defined. All inputs must have a valid value
      </b-form-invalid-feedback>
    </div>
    <div class="p-0 m-0">
      <b-form-input
        v-model="x0Value"
        :state="(x1Value === '' && x0Value === '' && intercpValue === '') || (x0Value !== '' && !isNaN(x0Value))"
        aria-describedby="input-live-help input-live-feedback"
        placeholder="X0"
        trim
        size="sm"
        @change="updateCoefficients"
      />
      <b-form-invalid-feedback class="input-live-feedback">
        If one variable is defined. All inputs must have a valid value
      </b-form-invalid-feedback>
    </div>
    <div class="p-0 m-0">
      <b-form-input
        v-model="intercpValue"
        :state="(x1Value === '' && x0Value === '' && intercpValue === '') || (intercpValue !== '' && !isNaN(intercpValue))"
        aria-describedby="input-live-help input-live-feedback"
        placeholder="(Intercept)"
        trim
        size="sm"
        @change="updateCoefficients"
      />
      <b-form-invalid-feedback class="input-live-feedback">
        If one variable is defined. All inputs must have a valid value
      </b-form-invalid-feedback>
    </div>
    <TextInputConfiguration
      :controller="DilutionCtrller"
      :sizeinput="'sm'"
      :forcerow="false"
    />
  </div>
</template>

<script>
import TextInputConfiguration from '@/components/properties/elements/TextInputConfiguration'
import {hiddenConfCtrller, inputTextConfCtrller} from '@/assets/classes/configuration.js'
import { ConfigName } from '@/common/sharedDefinitions/commonPlotDefinitions'
import { mapActions } from 'vuex'

const zoneNotify = 'FitQuadraticModel'

export default {
  name: 'Quadratic',
  components:{
    TextInputConfiguration
  },
  props: {
    sectionconfig:{
      type:String,
      required:true
    },
    fitname:{
      type:String,
      required:true
    }
  },
  data() {
    return {
      x0Value:'',
      x1Value:'',
      intercpValue:'',
      elementsConfig:[],
      customCoefs: new hiddenConfCtrller(`${ConfigName.BaseCurveFit}.{0}.CustomCoefs`,[]),
      DilutionCtrller:new inputTextConfCtrller(`${ConfigName.BaseCurveFit}.{0}.DilutionFactor`,'Dilution factor','Please provide a valid Dilution Factor','1',(value)=>{return value !==''}),
      initializing:false
    }
  },
  async mounted(){
    this.elementsConfig = [
      this.customCoefs,
      this.DilutionCtrller
    ]
    //Delay the initialization so it can read the most updated values
    await this.$nextTick()
    await this.$nextTick()
    await this.$nextTick()
    try{
      this.initializing = true
      this.elementsConfig.forEach(conf=>conf.configCategory=this.sectionconfig)
      this.elementsConfig.forEach(conf=>conf.formatKeyValue(this.fitname))
      this.elementsConfig.forEach(conf=>conf.setParent(this))
      if(this.customCoefs.value.length === 3){
        this.x1Value = this.customCoefs.value[0]
        this.x0Value = this.customCoefs.value[1]
        this.intercpValue = this.customCoefs.value[2]
      }else{
        this.x0Value = ''
        this.x1Value = ''
        this.intercpValue = ''
      }
    }catch{
      const infoTitle='Quadratic Fit Error'
      const infoText='The report stored in the system has different structure. Please contact your administrator.'
      this.$notifTerm.addNotification(this.$notifTerm.typesNotif.INFO,infoTitle,infoText,zoneNotify)
    }finally{
      this.initializing = false
    }
  },
  methods:{
    ...mapActions(['setConfigReportModifiedReportViewer']),
    updateCoefficients(){
      if(this.initializing){
        return
      }
      if(this.x1Value === '' || isNaN(this.x1Value) || this.x0Value === '' || isNaN(this.x0Value) || this.intercpValue === '' || isNaN(this.intercpValue)){
        this.customCoefs.setValue([])
      }else{
        this.customCoefs.setValue([parseFloat(this.x1Value), parseFloat(this.x0Value), parseFloat(this.intercpValue)])
      }
      this.setConfigReportModifiedReportViewer()
    }
  }
}
</script>

<style>

</style>
